import { createContext, useContext } from 'react';

export interface IBrandingContext {
    /** Public URL of the mandant's logo, if it has one. */
    logoUrl?: string;
}

export const BrandingContext = createContext<IBrandingContext>({});

export function useBranding(): IBrandingContext {
    return useContext(BrandingContext);
}
